import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Message } from "element-ui";

export async function GetProducts({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("GET_PRODUCTS_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/item", option);
    commit("GET_PRODUCTS_SUCCESS", {
      results: {
        data: _response.data.data.items.rows,
        totalPage: Math.ceil(
          _response.data.data.items.count / option.params.limit
        ),
        count: _response.data.data.items.count
      }
    });
  } catch (error) {
    commit("GET_PRODUCTS_ERROR", { result: error.message });
  }
}

export async function CreateProduct({ commit }, form) {
  try {
    ApiService.init();
    commit("CREATE_PRODUCT_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/productmanagement", form);
    commit("CREATE_PRODUCT_SUCCESS", { results: _response });
    router.push("/product");
  } catch (error) {
    commit("CREATE_PRODUCT_ERROR", { result: error.message });
  }
}

export async function GetProduct({ commit }, id) {
  try {
    ApiService.init("heroku");
    commit("GET_PRODUCT_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get(`/v1/item/${id}`);
    commit("GET_PRODUCT_SUCCESS", { results: _response });
  } catch (error) {
    commit("GET_PRODUCT_ERROR", { result: error.message });
  }
}

export async function GetProductQuery({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("GET_PRODUCT_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query(`/v1/item/${option.id}`,option);
    commit("GET_PRODUCT_SUCCESS", { results: _response });
  } catch (error) {
    commit("GET_PRODUCT_ERROR", { result: error.message });
  }
}

export async function UpdateProduct({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_PRODUCT_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put(
      "/v1/item/" + form.oracleItemId,
      form
    );
    commit("EDIT_PRODUCT_SUCCESS", { results: _response });
    Message({
      message: "Update completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("EDIT_PRODUCT_ERROR", { result: error.message });
    Message({
      message: error.response.data.errors.message,
      type: "error"
    });
  }
}

export async function UpdateStatusProduct({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_PRODUCT_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/v1/item/" + form.id, form);
    commit("EDIT_PRODUCT_SUCCESS", _response);
    Message({
      message: "Update completed",
      type: "success"
    });
  } catch (error) {
    commit("EDIT_PRODUCT_ERROR", { result: error.message });
  }
}

export async function DeleteProduct({ commit }, id) {
  try {
    ApiService.init();
    commit("DELETE_PRODUCT_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/productmanagement/" + id);
    commit("DELETE_PRODUCT_SUCCESS", { id: id });
  } catch (error) {
    commit("DELETE_PRODUCT_ERROR", { result: error.message });
  }
}
